import React from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
// Default theme
import "@splidejs/react-splide/css";
import { Link } from "react-router-dom";
 
import defaultUser from '../assets/images/default_profile_pic.jpg';

export default function Feedback() {
  return (
    <>
      {/* <!-- FeedBack START --> */}
      <section className="bds-main-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="bds-feedbackwrap">
                <div className="bds-main-title-holder">
                  <div className="bds-maintitle">
                    <h2>
                      Seriously posstive feedback always keep us motivated
                    </h2>
                  </div>
                  <div className="bds-main-description">
                    <p>
                      Meet some of our Users that are making the 3bids community great, how and why they do what they do.
                    </p>
                  </div>
                </div>
                  <Link to="/signup">
                  <a className="bds-btn-solid-lg">
                    Join us today <i className="icon-user-check"></i>
                  </a>                
                </Link>
              </div>
            </div>
          </div>
        </div>

        <Splide
          aria-label="My Favorite Images"
          className="bds-feedbackslider"
          options={{
            type   : 'loop',
            perPage: 3,
            perMove: 1,
            autoplay: true,
            arrows: false,
            pagination: false,
            gap: 24,
            interval: 3000,
            autoWidth: true,
            breakpoints: {
                1199: {
                perPage: 2,
                },
                991: {
                perPage:2,
                pagination: false,
                },
                767: {
                perPage:1,
                arrows:false,
                pagination: true,
                },
                480: {
                perPage:1,
                arrows:false,
                pagination: true,
                autoWidth: false,
                focus  : 'center',
                gap: 12,
                },
            }
          }}
        >
          <SplideSlide>
            <div className="bds-feedbackitem">
              <figure>
                <img src={defaultUser} alt="image" width={100} height={100}   />
              </figure>
              <div className="bds-feedbackinfo">
                <h4>NASIR HUSSAIN</h4>
                <h6>
                    <Link to="#" className="lh-sm">
                      Cleaning, Electrician, Moving, Ac Service
                  </Link>
                </h6>
                <p>
                  Nasir has done an excellent job of instant geyser installation & his customer service and after-work service is awesome too.
                </p>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
                <div className="bds-feedbackitem">
                  <figure>
                    <img src={defaultUser} alt="image" width={100} height={100}   />
                  </figure>
                  <div className="bds-feedbackinfo">
                    <h4>HAMZA CHAUDHARY</h4>
                    <h6>
                        <Link to="#" className="lh-sm">
                        IT services, photographers, designer
                      </Link>
                    </h6>
                    <p>
                      He did a great job and delivered it on time. He is very hard working. I will work with him again in future. Highly recommended!!!
                    </p>
                  </div>
                </div>
          </SplideSlide>
          <SplideSlide>
                <div className="bds-feedbackitem">
                  <figure>
                    <img src={defaultUser} alt="image" width={100} height={100}   />
                  </figure>
                  <div className="bds-feedbackinfo">
                    <h4>MEHMOOD ALI</h4>
                    <h6>
                        <Link to="#" className="lh-sm">
                        cleaning, painter, car washer, moving
                      </Link>
                    </h6>
                    <p>
                    Extremely hard working and honest towards his work with good polite temperament. Highly recommended
                    </p>
                  </div>
                </div>
          </SplideSlide>
        </Splide>

      </section>
      {/* <!-- FeedBack END --> */}
    </>
  );
}
